import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class userinfo
{

    public InsuredName:string;
    
        private subject = new Subject<any>();
    
        setUserInfo(InsuredName: string) {
           
            this.subject.next(InsuredName);
        }
    
        getUserInfo(): Observable<string> {
            if(sessionStorage.getItem("InsuredName")!=null)
            {
                this.InsuredName=sessionStorage.getItem("InsuredName");
               // alert(this.Userinfo+"---");
               // this.subject.next(this.InsuredName);
            }
            return this.subject.asObservable();
        }
    

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/userinfo.ts